const ICONE = 'image:///media/icons/duotune/files/fil021.svg';

/**
 * Referencia estrutural em vez de React.RefObject para o modulo nao
 * precisar importar React num arquivo sem JSX.
 */
export interface RefDeChart {
    current: any;
}

/**
 * Toolbox de download em PNG e SVG. O PNG e gerado manualmente porque o
 * saveAsImage do ECharts nao aceita pixelRatio.
 */
export function toolboxDownload(ref: RefDeChart, nomeArquivo: string) {
    return {
        itemSize: 24,
        orient: 'horizontal',
        feature: {
            mySaveAsPng: {
                show: true,
                title: 'Salvar Gráfico como Imagem',
                icon: ICONE,
                onclick: () => {
                    const chartInstance = ref.current?.getEchartsInstance();
                    const url = chartInstance?.getDataURL({
                        type: 'png',
                        pixelRatio: 3,
                        excludeComponents: ['toolbox'],
                    });
                    if (!url) return;

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${nomeArquivo}.png`;
                    a.click();
                    a.remove();
                },
            },

            saveAsImage: {
                title: 'Salvar Gráfico como SVG',
                name: nomeArquivo,
                type: 'svg',
                icon: ICONE,
            },
        },
    };
}
